import React from 'react';

import Request from '@scripts/request.js';

import ResponsiveEmbed from '../ResponsiveEmbed/index.jsx';


// the base-url for the Dune Analytics price chart we've built. We pass in the
// primary contract address for the collection of interest.
const PRICE_CHART_BASE_URL = 'https://dune.com/embeds/1327053/2268169/d7ddc9f2-4d7d-4e38-9e01-7b957388b332';
const PRICE_CHART_QUERY_PARAM = 'addr';


class NFTPriceChart extends React.Component {
  render() {
    if (this.props.address) {
      var url = Request.updateQueryStringParameter(
        PRICE_CHART_BASE_URL,
        PRICE_CHART_QUERY_PARAM,
        this.props.address
      );
      var iframe = '<iframe src="' + url + '" />';

      return (
        <div className="cs-block-nft-price-chart__container">
          <ResponsiveEmbed embed={iframe} variant={[ 'clear', 'nft-price-chart' ]} />
        </div>
      );
    } else {
      return null;
    }
  }
}


export default NFTPriceChart;

